// @ts-nocheck
import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.png';
import { motion } from 'framer-motion';

const Navbar = ({ onSectionChange }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Define navigation items with their respective section IDs
  const navItems = [
    { name: 'Home', id: 'home' },
    { name: 'About Us', id: 'about-us' },
    { name: 'Services', id: 'services' },
    { name: 'Pricing', id: 'pricing' },
    { name: 'Projects', id: 'projects' } // Updated to use the new projects ID
  ];

  // Function to scroll to a specific section
  const scrollToSection = (id) => {
    // For pricing, we just update the active section
    if (id === 'pricing') {
      onSectionChange('pricing');
    } else {
      // For other sections, scroll to them
      onSectionChange(id);
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    // Close mobile menu if open
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-background/90 backdrop-blur-md py-3 shadow-lg' : 'bg-transparent py-5'
      }`}
    >
      <div className="container flex justify-between items-center">
        {/* Logo */}
        <div className="flex items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center"
          >
            <img 
              src={logo}
              alt="Link Bridge Consulting Logo" 
              className="h-7 w-7 md:h-8 md:w-8 mr-1 md:mr-2"
            />
          </motion.div>
          <div className="flex flex-col">
            <span className="font-montserrat font-bold text-[14px] md:text-[18px] leading-tight tracking-normal text-white uppercase">
              <span className="text-white">LINK BRIDGE</span>
            </span>
            <span className="font-montserrat font-normal text-[12px] md:text-[14px] leading-tight tracking-normal text-[#FEFEFE] uppercase">
              <span className="text-[#FEFEFE]">CONSULTING</span>
            </span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          {navItems.map((item) => (
            <a
              key={item.name}
              href={`#${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(item.id);
              }}
              className="text-text-primary hover:text-primary transition-colors duration-300"
            >
              {item.name}
            </a>
          ))}
          <button 
            onClick={() => {
              onSectionChange('home');
              const footerSection = document.getElementById('footer-section');
              if (footerSection) {
                footerSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-white text-primary hover:bg-primary/10 transition-colors duration-300 px-6 py-2 rounded-full font-medium cursor-pointer"
          >
            Contact Us
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-text-primary focus:outline-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6"
            >
              {isMobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-background/95 backdrop-blur-md absolute w-full py-6 px-6 shadow-lg border-t border-white/10 animate-fadeIn">
          <div className="flex flex-col space-y-5">
            {navItems.map((item) => (
              <a
                key={item.name}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.id);
                }}
                className="text-white hover:text-primary py-2 transition-colors duration-300 text-lg font-medium"
              >
                {item.name}
              </a>
            ))}
            <button 
              onClick={() => {
                setIsMobileMenuOpen(false);
                onSectionChange('home');
                const footerSection = document.getElementById('footer-section');
                if (footerSection) {
                  footerSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="bg-white text-primary hover:bg-primary/10 transition-colors duration-300 px-6 py-3 rounded-full font-medium w-full cursor-pointer mt-2"
            >
              Contact Us
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;